import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { IonicModule} from "@ionic/angular";
import { HttpClientModule} from "@angular/common/http";

@NgModule({
    imports: [FormsModule, CommonModule, RouterModule, ReactiveFormsModule, HttpClientModule, IonicModule.forRoot()],
    exports: [FormsModule, CommonModule, RouterModule, ReactiveFormsModule, HttpClientModule, IonicModule]
})
export class AppSharedLibsModule {
    static forRoot() {
        return {
            ngModule: AppSharedLibsModule
        };
    }
}
